export const BACKEND_UNAVAILABLE_RELOAD_GUARD =
  'pamir:backend-unavailable:auto-reload';

export const BACKEND_UNAVAILABLE_RELOAD_COOLDOWN = 60_000;